<template>
  <div>
    <v-row>
      <v-col cols="12" md="8" class="mx-auto">
        <v-card outlined style="position: relative; border-radius: 16px">
          <v-card-title>
            <app-title>Mensagens</app-title>
          </v-card-title>
          <v-card-text>
            <v-alert dense outlined colored-border border="left" type="info" color="primary" class="mb-6">
              Utilize as tags abaixo de cada mensagem para que ela seja autocompletada pelo sistema.
            </v-alert>

            <!-- Mensagem de Cobrança Mensal -->
            <div class="message-section">
              <div class="section-header">
                <div class="section-title">
                  <app-icon left>calendar_month</app-icon>
                  Cobrança Mensal
                  <v-chip x-small class="ml-2" color="success" dark>Automático</v-chip>
                </div>
                <v-btn v-if="$acl.isProfessional()" @click="handleTextGenerationForm('message_billing')" small outlined
                  color="primary" class="btn-ai">
                  <app-icon left class="mr-1">wand_stars</app-icon>
                  I.A
                </v-btn>
              </div>

              <v-textarea id="message_billing" v-model="form.message_billing" outlined hide-details auto-grow rows="3"
                class="mb-3" />

              <div class="tags-section">
                <p class="tags-label">Tags disponíveis:</p>
                <div class="tags-wrapper">
                  <v-chip v-for="tag in [...commonTags, ...monthBillingTags]" :key="tag.value" class="tag-chip ma-1"
                    @click="tagInsert('message_billing', tag.value)" outlined small>
                    {{ tag.label }}
                  </v-chip>
                </div>
              </div>
            </div>

            <v-divider class="my-6" />

            <!-- Mensagem de Cobrança Manual -->
            <div class="message-section">
              <div class="section-header">
                <div class="section-title">
                  <app-icon left>receipt</app-icon>
                  Cobrança
                  <v-chip x-small class="ml-2" color="grey" dark>Manual</v-chip>
                </div>
                <v-btn v-if="$acl.isProfessional()" @click="handleTextGenerationForm('transaction_billing_message')"
                  small outlined color="primary" class="btn-ai">
                  <app-icon left class="mr-1">wand_stars</app-icon>
                  I.A
                </v-btn>
              </div>

              <v-textarea id="transaction_billing_message" v-model="form.transaction_billing_message" outlined
                hide-details auto-grow rows="3" class="mb-3" />

              <div class="tags-section">
                <p class="tags-label">Tags disponíveis:</p>
                <div class="tags-wrapper">
                  <v-chip v-for="tag in [...commonTags, ...billingMessageOptions]" :key="tag.value"
                    class="tag-chip ma-1" @click="tagInsert('transaction_billing_message', tag.value)" outlined small>
                    {{ tag.label }}
                  </v-chip>
                </div>
              </div>
            </div>

            <v-divider class="my-6" />

            <!-- Lembrete de Sessão -->
            <div class="message-section">
              <div class="section-header">
                <div class="section-title">
                  <div>
                    <div>
                      <app-icon left>notifications</app-icon>
                      Lembrete de Sessão
                    </div>
                    <small>
                      * Este é modelo de é pré-aprovado pela Meta, não pode ser alterado.
                    </small>
                  </div>
                </div>

              </div>

              <v-textarea id="session_reminder_message" :value="sessionReminderMessage" outlined hide-details auto-grow
                disabled rows="3" />

              <small class="mb-3">
                * Este é modelo de é pré-aprovado pela Meta, não pode ser alterado.
              </small>


            </div>

            <v-divider class="my-6" />

            <!-- Lembrete de Sessão Suspensa -->
            <div class="message-section">
              <div class="section-header">
                <div class="section-title">
                  <div>
                    <div>
                      <app-icon left>notifications</app-icon>
                      Lembrete de Sessão Suspensa
                    </div>

                  </div>
                </div>

              </div>

              <v-textarea id="session_suspended_message" :value="sessionSuspendedMessage" outlined hide-details disabled
                auto-grow rows="3" />

              <small class="mb-3">
                * Este é modelo de é pré-aprovado pela Meta, não pode ser alterado.
              </small>
            </div>

            <v-divider class="my-6" />

            <!-- Configurações -->
            <div class="settings-section">
              <div class="section-title mb-3">
                <app-icon left>settings_suggest</app-icon>
                Outras Configurações


              </div>

              <v-switch v-model="form.session_reminder_enable_cancellation" label="Habilitar reagendamento"
                :true-value="1" :false-value="0"
                :hint='`Permite que o ${customer_alias} solicite reagendamento pelo lembrete`' persistent-hint />
            </div>
          </v-card-text>
          <v-card-actions>
            <app-back-btn @click="$router.go(-1)" />
            <v-spacer v-if="$vuetify.breakpoint.mobile" />
            <app-confirm-btn @click="save()" class="mr-2" />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <TextGenerationForm ref="TextGenerationForm" @store="setText" />
  </div>
</template>

<script>
import { customerAlias } from "@/utils/customerAlias";
import TextGenerationForm from "@/components/assistant/forms/TextGenerationForm.vue";

export default {
  components: {
    TextGenerationForm
  },
  data() {
    return {
      form: {
        message_billing: null,
        transaction_billing_message: null,
        session_reminder_message: null,
        session_reminder_enable_cancellation: 0,
        suspended_message: null,
      },
      messageSection: null,
      customer_alias: customerAlias().toLowerCase(),

      commonTags: [
        {
          label: `Nome do ${customerAlias().toLowerCase()}`,
          value: `{nome_${customerAlias().toLowerCase()}}`,
        },
        {
          label: `Primeiro nome do ${customerAlias().toLowerCase()}`,
          value: `{primeiro_nome_${customerAlias().toLowerCase()}}`,
        },
        {
          label: 'Meu contato',
          value: '{meu_contato}',
        },
        {
          label: 'Link do meu contato',
          value: '{link_meu_contato}',
        },
        {
          label: 'Primeiro nome do profissional',
          value: '{primeiro_nome_profissional}',
        },
        {
          label: 'Nome do profissional',
          value: '{nome_profissional}',
        }
      ],

      monthBillingTags: [
        {
          value: '{nome_responsavel_financeiro}',
          label: 'Responsável financeiro',
        },
        {
          label: 'Detalhes',
          value: '{detalhes}'
        },
        {
          label: 'Valor',
          value: '{valor}',
        },
        {
          label: 'Valor por extenso',
          value: '{valor_extenso}',
        },
        {
          label: 'Valor da sessão',
          value: '{valor_sessao}',
        },
        {
          label: 'Valor da sessão por extenso',
          value: '{valor_sessao_extenso}',
        },
      ],

      billingMessageOptions: [
        {
          value: '{nome_responsavel_financeiro}',
          label: 'Responsável financeiro',
        },
        {
          label: "Valor",
          value: "{valor}",
        },
        {
          label: "Valor por extenso",
          value: "{valor_extenso}"
        },
        {
          label: "Descrição",
          value: "{descricao}"
        },
      ],

      sessionTags: [
        {
          label: 'Data',
          value: '{data}'
        },
        {
          label: 'Hora',
          value: '{hora}'
        },
      ],
    };
  },

  computed: {
    company() {
      return this.$store.state.auth.company;
    },

    sessionReminderMessage() {
      return "Lembrete de agendamento, Olá, {{nome_paciente}}, Este é um lembrete da sua sessão com {{nome_profissional}} em 02/12 às 14h."
    },

    sessionSuspendedMessage() {
      return "Olá {{nome_paciente}}, sua sessão com dr {{nome_profissional}}, agendada para 14/12/2025 às 14:30 hrs, foi suspensa."
    }
  },

  mounted() {
    this.$loading.start();
    this.$auth
      .getLoginData()
      .then((response) => {
        this.form = JSON.parse(JSON.stringify(this.company));
        this.$loading.finish();
      })
      .catch((error) => {
        this.$loading.finish();
      });
  },

  methods: {
    save() {
      this.$loading.start();
      this.$http
        .update("company/company", this.company.id, this.form)
        .then((response) => {
          this.$router.push("/configuracoes");
          this.$auth.getLoginData();
          this.$loading.finish();
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },

    tagInsert(id, value) {
      const textarea = document.getElementById(id);
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = textarea.value;
      const before = text.substring(0, start);
      const after = text.substring(end, text.length);
      textarea.value = before + value + after;
      textarea.focus();

      textarea.selectionStart = start + value.length;
      textarea.selectionEnd = start + value.length;

      this.form[id] = textarea.value;
    },

    handleTextGenerationForm(section) {
      this.messageSection = section;
      this.$refs.TextGenerationForm.open(this.form[section]);
    },

    setText(text) {
      this.form[this.messageSection] = text;
      this.messageSection = null;
    }
  },
};
</script>

<style scoped>
.message-section {
  position: relative;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.section-title {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.btn-ai {
  text-transform: none;
}

.tags-section {
  background: #F9FAFB;
  border-radius: 8px;
  padding: 12px;
}

.tags-label {
  font-size: 12px;
  color: #6B7280;
  margin-bottom: 8px;
}

.tags-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.tag-chip {
  cursor: pointer;
  transition: all 150ms ease-out;
  font-size: 12px;
}

.tag-chip:hover {
  background: #EEF2FF !important;
  border-color: #6B8AF6 !important;
  color: #6B8AF6 !important;
}

.settings-section {
  margin-top: 8px;
}

.v-chip {
  vertical-align: middle;
}
</style>
